/**
 * @desc 查询交货单号/箱码/PO单/sku编码/FNSKU编码
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.ResponseDto<ObjectMap>;
export function request(code: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierPAD/searchCode/${code}`, {
      method: "POST",

      ...options,
    }),
  );
}
